import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IDatiqAppInitializer } from '@dat/datiq-core/models';

@Injectable({
    providedIn: 'root',
})
export class DatiqIconsInitializerService implements IDatiqAppInitializer {
    // TODO: Update this version number when icons are updated in assets/datiq-icons/dat-icons.svg
    private readonly ICONS_VERSION = '1.0.3';

    constructor(
        private iconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
    ) {}

    initialize(): Promise<boolean> {
        const iconsUrl: string = `assets/datiq-icons/dat-icons.svg?v=${this.ICONS_VERSION}`;
        this.iconRegistry?.addSvgIconSetInNamespace(
            'app',
            this.domSanitizer?.bypassSecurityTrustResourceUrl(iconsUrl),
        );
        return new Promise<boolean>((res) => res(true));
    }
}
